import React from 'react'

function Footer() {

    const year = new Date().getFullYear()

    // const socialLinks = [
    //     {
    //         name: 'Facebook',
    //         url: 'https://www.facebook.com/'
    //     },
    //     {
    //         name: 'Instagram',
    //         url: 'https://www.instagram.com/'
    //     },
    //     {
    //         name: 'Twitter',
    //         url: 'https://www.twitter.com/'
    //     }
    // ]

    return(
        <footer id="footerSection">
            <div className="container-fluid-small">

                {/* <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 footer-title anim-bot">
                        <h2 className="big-title">Let's work together.</h2>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 footer-project anim-bot">
                        <Link to='/contact'>Start a project</Link>
                    </div>
                </div> */}

                {/* <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-4 copyright">
                        <p>Copyright © {year} 2021 OITID STUDENT EDITION.</p>
                        <div className="footer-menu">
                            <ul>
                                {socialLinks.map((item, i) => <li key={i}><a href={item.url}>{item.name}</a></li>)}
                            </ul>
                        </div>
                    </div>
                    <div className="col-1 footer-offset"></div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 contact-box contact-mail">
                        <h5 className="sub-title">Email</h5>
                        <ul>
                            <li>〇〇〇〇〇@〇〇〇〇</li>
                            <li>〇〇〇〇〇@〇〇〇〇</li>
                        </ul>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 contact-box contact-address">
                        <h5 className="sub-title">Contact Us</h5>
                        <ul>
                            <li>〒000-0000</li>
                            <li>大阪府〇〇〇〇〇〇〇〇〇〇〇〇</li>
                            <li>9:00 AM - 6:00 PM</li>
                        </ul>
                    </div>
                </div> */}


                <div className="copyright">   
                    <p>Copyright © {year} OITID STUDENT EDITION.</p>
                </div>
                
                <div className="footer-logo">
                    <a className="logo_oit" href="https://www.oit.ac.jp/"><img src="/oitid/student/assets/images/logo_oit.svg" alt="大阪工業大学"/></a>
                    <a className="logo_id" href="https://www.research.oit.ac.jp/oitid/"><img src="/oitid/student/assets/images/logo_id.svg" alt="INNOVATION DAYS 智と技術の見本市"/></a>
                </div>
                
            </div>
        </footer>
    )
}

export default Footer